function isHorSovathana(user) {
	return /Hor Sovathana/.test(user?.fullName) && /ហោ សុវឌ្ឍនា/.test(user?.fullNameKhmer);
}

function isTanLinna(user) {
	return /Tan Linna/.test(user?.fullName) && /តាន់ លីនណា/.test(user?.fullNameKhmer);
}

function isNganChakrya(user) {
	return /Ngan Chakrya/.test(user?.fullName) && /ង៉ាន់ ចរិយា/.test(user?.fullNameKhmer);
}

function isUmKompheavin(user) {
	return /Um Kompheavin/.test(user?.fullName) && /អ៊ុំ កុម្ភាវីន/.test(user?.fullNameKhmer);
}

export { isHorSovathana, isTanLinna, isNganChakrya, isUmKompheavin };
